import $ from 'jquery';
import 'slick-carousel';

var $slider = $('.js-slider');

$slider.on('init', function () {
    $('.slider__load-image').hide();
});

$slider.slick({
    autoplay: true,
    autoplaySpeed: 7000,
    infinite: true,
    arrows: true,
    dots: false,
    draggable: false,
    prevArrow: '<a href="#" aria-label="Vorheriger Slide" class="slick-prev fa-thin fa-chevron-left"></a>',
    nextArrow: '<a href="#" aria-label="Nächster Slide" class="slick-next fa-thin fa-chevron-right"></a>',
    appendArrows: $('<div>').addClass('absolute-container arrow-container').insertAfter('.js-slider'),
    responsive: [{
        breakpoint: 992,
        settings: {
            draggable: true
        }
    }]
});
